import React from 'react';
import './HeroSection.css';
import ParticleBackground from './ParticleBackground';

const HeroSection = () => {
  const handleLaunchApp = () => {
    // 在新标签页中打开应用
    window.open('https://app.cricket-ai.xyz/', '_blank');
  };

  const handleLearnMore = () => {
    // 滚动到下一个section
    window.open('https://app.cricket-ai.xyz/missions', '_blank');
  };

  const handleNavClick = (elementId) => {
    document.getElementById(elementId)?.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
  };

  return (
    <section className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900 relative overflow-hidden flex flex-col">
      {/* 使用专业版粒子背景 */}
      <ParticleBackground />
      <div className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-blue-400/50 to-transparent animate-pulse duration-3000 delay-1500"></div>
      
      {/* 导航栏 */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-gray-900/95 backdrop-blur-sm border-b border-blue-500/20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="flex justify-between items-center py-3 sm:py-4">
            <div className="flex items-center gap-2 text-xl sm:text-2xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
              <img 
                src="/cricket32x32.png" 
                alt="Cricket AI Logo" 
                className="w-6 h-6 sm:w-8 sm:h-8"
              />
              Cricket AI
            </div>
            
            {/* 桌面端导航 */}
            <div className="hidden md:flex items-center gap-8">
              <a 
                href="#features" 
                className="text-gray-300 hover:text-blue-400 font-medium transition-colors"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick('features');
                }}
              >
                Features
              </a>
              <a 
                href="#how-it-works" 
                className="text-gray-300 hover:text-blue-400 font-medium transition-colors"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick('how-it-works');
                }}
              >
                How It Works
              </a>
              <button 
                onClick={handleLaunchApp}
                className="px-4 sm:px-6 py-2 sm:py-2.5 bg-gradient-to-r from-blue-500 via-blue-600 to-purple-600 text-white font-bold rounded-xl hover:shadow-lg hover:shadow-blue-500/25 hover:-translate-y-0.5 transition-all duration-300 text-sm sm:text-base"
              >
                Launch App
              </button>
            </div>

            {/* 移动端只显示 Launch App 按钮 */}
            <button 
              className="md:hidden px-4 py-2 bg-gradient-to-r from-blue-500 via-blue-600 to-purple-600 text-white font-bold rounded-xl hover:shadow-lg hover:shadow-blue-500/25 transition-all duration-300 text-sm"
              onClick={handleLaunchApp}
            >
              Launch App
            </button>
          </div>
        </div>
      </nav>

      {/* Hero内容 */}
      <div className="flex-1 flex items-center justify-center px-4 sm:px-6 pt-24 sm:pt-32 relative z-0" style={{ marginTop: window.innerWidth < 768 ? '60%' : '12%' }}>
        <div className="w-full max-w-6xl mx-auto">
          {/* 标题区域 - 使用flex布局 */}
          <div className="flex items-center justify-center gap-6 sm:gap-8 md:gap-12 mb-8 sm:mb-12">
            {/* 蟋蟀图片 - 只在桌面端显示 */}
            {/* <div className="hidden md:block flex-shrink-0">
              <img 
                src="/images/cricket.png" 
                alt="Cricket" 
                className="w-16 h-16 sm:w-24 sm:h-24 md:w-32 md:h-32 lg:w-48 lg:h-48 xl:w-56 xl:h-56 object-contain animate-fade-in-up"
              />
            </div> */}
            
            {/* 标题文字 */}
            <div className="text-center">
              <div className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-extrabold text-white leading-[1.1] tracking-tight mb-3 sm:mb-4 animate-fade-in-up">
                Predict Crypto Market
              </div>
              <div className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-extrabold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent leading-[1.2] sm:leading-[1.4] tracking-tight pb-2 overflow-visible animate-fade-in-up-delay">
                with <span className="text-orange-400">A</span>rtificial <span className="text-orange-400">I</span>ntelligence
              </div>
            </div>
          </div>
          
          <div className="space-y-1 sm:space-y-2 mb-12 sm:mb-16 animate-fade-in-up-delay-2">
            <div className="text-lg sm:text-xl md:text-2xl text-gray-300 leading-[1.5] sm:leading-[1.6] font-light">
              Turn market knowledge into real rewards.
            </div>
            <div className="text-lg sm:text-xl md:text-2xl text-gray-300 leading-[1.5] sm:leading-[1.6] font-light">
              AI-powered insights meet human intuition.
            </div>
          </div>
          
          <div className="mt-12 sm:mt-16 flex flex-col sm:flex-row gap-4 sm:gap-8 justify-center items-center animate-fade-in-up-delay-3">
            <button 
              onClick={handleLaunchApp}
              className="w-full sm:w-auto px-6 sm:px-12 py-3 sm:py-5 bg-gradient-to-r from-blue-500 via-blue-600 to-purple-600 text-white text-base sm:text-xl font-bold rounded-xl sm:rounded-2xl hover:shadow-xl hover:shadow-blue-500/25 hover:-translate-y-1 transition-all duration-300 sm:min-w-[200px] whitespace-nowrap"
            >
              Launch App
            </button>
            <button 
              onClick={handleLearnMore}
              className="w-full sm:w-auto px-6 sm:px-12 py-3 sm:py-5 bg-white/10 border-2 border-gray-400/30 text-white text-base sm:text-xl font-bold rounded-xl sm:rounded-2xl hover:bg-white/20 hover:border-blue-400 hover:-translate-y-1 transition-all duration-300 sm:min-w-[200px] backdrop-blur-sm whitespace-nowrap"
            >
              Get CRICKET
            </button>
          </div>
        </div>
      </div>

      {/* 滚动提示 */}
      {/* <div className="absolute bottom-6 sm:bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce z-10">
        <div className="text-xl sm:text-2xl text-gray-400">↓</div>
      </div> */}
    </section>
  );
};

export default HeroSection;
